import {
  Component, ChangeDetectionStrategy, inject, NgZone,
  OnInit, OnDestroy, signal, input,
} from '@angular/core';

@Component({
  selector: 'widget-analog-saat',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg [attr.viewBox]="'0 0 200 200'" class="analog-saat">
      <circle cx="100" cy="100" r="95" class="kadran"/>
      @for (i of saatCizgileri; track i) {
        <line
          [attr.x1]="100 + 80 * Math.sin(i * 30 * RAD)"
          [attr.y1]="100 - 80 * Math.cos(i * 30 * RAD)"
          [attr.x2]="100 + 90 * Math.sin(i * 30 * RAD)"
          [attr.y2]="100 - 90 * Math.cos(i * 30 * RAD)"
          class="saat-cizgi"/>
      }
      @for (i of dakikaCizgileri; track i) {
        <line
          [attr.x1]="100 + 85 * Math.sin(i * 6 * RAD)"
          [attr.y1]="100 - 85 * Math.cos(i * 6 * RAD)"
          [attr.x2]="100 + 90 * Math.sin(i * 6 * RAD)"
          [attr.y2]="100 - 90 * Math.cos(i * 6 * RAD)"
          class="dakika-cizgi"/>
      }
      @if (rakamGoster()) {
        @for (i of saatCizgileri; track i) {
          <text
            [attr.x]="100 + 70 * Math.sin(i * 30 * RAD)"
            [attr.y]="100 - 70 * Math.cos(i * 30 * RAD) + 5"
            class="rakam">{{ i === 0 ? 12 : i }}</text>
        }
      }
      <line x1="100" y1="100"
        [attr.x2]="100 + 50 * Math.sin(akrepAci() * RAD)"
        [attr.y2]="100 - 50 * Math.cos(akrepAci() * RAD)"
        class="akrep"/>
      <line x1="100" y1="100"
        [attr.x2]="100 + 70 * Math.sin(yelkovanAci() * RAD)"
        [attr.y2]="100 - 70 * Math.cos(yelkovanAci() * RAD)"
        class="yelkovan"/>
      <line x1="100" y1="100"
        [attr.x2]="100 + 75 * Math.sin(saniyeAci() * RAD)"
        [attr.y2]="100 - 75 * Math.cos(saniyeAci() * RAD)"
        class="saniye"/>
      <circle cx="100" cy="100" r="4" class="merkez"/>
    </svg>
  `,
  styles: [`
    :host { display: block; width: 100%; height: 100%; }
    .analog-saat { width: 100%; height: 100%; }
    .kadran { fill: var(--py-arkaplan, #1a1a2e); stroke: var(--py-metin, #e0e0e0); stroke-width: 2; }
    .saat-cizgi { stroke: var(--py-metin, #e0e0e0); stroke-width: 2.5; stroke-linecap: round; }
    .dakika-cizgi { stroke: var(--py-metin-ikincil, #888); stroke-width: 1; stroke-linecap: round; }
    .rakam { fill: var(--py-metin, #e0e0e0); font-size: 14px; text-anchor: middle; font-weight: 600; }
    .akrep { stroke: var(--py-metin, #e0e0e0); stroke-width: 5; stroke-linecap: round; }
    .yelkovan { stroke: var(--py-metin, #e0e0e0); stroke-width: 3; stroke-linecap: round; }
    .saniye { stroke: #f5222d; stroke-width: 1.5; stroke-linecap: round; }
    .merkez { fill: #f5222d; }
  `],
})
export class AnalogSaatComponent implements OnInit, OnDestroy {
  private zone = inject(NgZone);

  rakamGoster = input(false);

  akrepAci = signal(0);
  yelkovanAci = signal(0);
  saniyeAci = signal(0);

  readonly Math = Math;
  readonly RAD = Math.PI / 180;
  readonly saatCizgileri = Array.from({ length: 12 }, (_, i) => i);
  readonly dakikaCizgileri = Array.from({ length: 60 }, (_, i) => i).filter(i => i % 5 !== 0);

  private intervalId: any;

  ngOnInit() {
    this.guncelle();
    this.intervalId = setInterval(() => this.guncelle(), 1000);
  }

  private guncelle() {
    const now = new Date();
    const s = now.getSeconds();
    const m = now.getMinutes() + s / 60;
    const h = (now.getHours() % 12) + m / 60;
    this.zone.run(() => {
      this.saniyeAci.set(s * 6);
      this.yelkovanAci.set(m * 6);
      this.akrepAci.set(h * 30);
    });
  }

  ngOnDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
}
